import React from "react";
import { Box } from "@mui/material";
// Same flag icon package PhoneNumberField.jsx already uses — see that
// file's comment on why `react-phone-number-input/flags` isn't used
// instead. Importing the same package here adds zero new weight.
import * as flags from "country-flag-icons/react/3x2";
import { getCurrencyCountry } from "../../utils/currencyCountries";

// Renders a small flag for a currency code, or nothing if the code isn't in
// our hand-maintained currency->country map (see currencyCountries.js) —
// never throws/renders broken for an admin-typed currency we don't know.
const CurrencyFlag = ({ code, size = 16 }) => {
  const info = getCurrencyCountry(code);
  const FlagComponent = info && flags[info.country];
  if (!FlagComponent) return null;

  return (
    <Box
      component={FlagComponent}
      sx={{ width: size, height: size * (2 / 3), borderRadius: 0.5, flexShrink: 0, display: "block" }}
    />
  );
};

export default CurrencyFlag;
